"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactDragDrawer = _interopRequireDefault(require("react-drag-drawer"));

var _IconActionClose = _interopRequireDefault(require("../Icons/IconActionClose"));

var _cogoToast = _interopRequireDefault(require("cogo-toast"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StepModalContext = /*#__PURE__*/(0, _react.createContext)();

var StyledModalActions = function StyledModalActions(_ref) {
  var children = _ref.children,
      position = _ref.position,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(ModalActions, {
    className: className,
    position: position
  }, children);
};

var ModalContent = function ModalContent(_ref2) {
  var children = _ref2.children,
      step = _ref2.step;

  var _useContext = (0, _react.useContext)(StepModalContext),
      currentStep = _useContext.currentStep;

  return currentStep === step ? children : null;
};

var ModalWithSteps = function ModalWithSteps(_ref3) {
  var canClose = _ref3.canClose,
      children = _ref3.children,
      showModal = _ref3.showModal,
      setShowModal = _ref3.setShowModal,
      small = _ref3.small,
      large = _ref3.large,
      className = _ref3.className,
      steps = _ref3.steps,
      currentStep = _ref3.currentStep,
      visualSteps = _ref3.visualSteps,
      title = _ref3.title,
      _ref3$stepText = _ref3.stepText,
      stepText = _ref3$stepText === void 0 ? 'Step' : _ref3$stepText,
      showToast = _ref3.showToast,
      toastText = _ref3.toastText,
      toastHideTime = _ref3.toastHideTime,
      onClose = _ref3.onClose,
      otherProps = _objectWithoutProperties(_ref3, ["canClose", "children", "showModal", "setShowModal", "small", "large", "className", "steps", "currentStep", "visualSteps", "title", "stepText", "showToast", "toastText", "toastHideTime", "onClose"]);

  var isShowingToast = (0, _react.useRef)(false);

  var handleOnRequestClose = function handleOnRequestClose() {
    if (canClose) {
      setShowModal(!showModal);
      onClose();
    }

    if (showToast && !isShowingToast.current) {
      isShowingToast.current = true;

      _cogoToast.default.warn(toastText, {
        hideAfter: toastHideTime
      });

      setTimeout(function () {
        isShowingToast.current = false;
      }, toastHideTime * 1000);
    }
  };

  return /*#__PURE__*/_react.default.createElement(StepModalContext.Provider, {
    value: {
      currentStep: currentStep
    }
  }, /*#__PURE__*/_react.default.createElement(StyledDrawer, {
    open: showModal,
    onRequestClose: handleOnRequestClose
  }, /*#__PURE__*/_react.default.createElement(ModalContainer, _extends({
    className: className,
    small: small,
    large: large
  }, otherProps), /*#__PURE__*/_react.default.createElement(ModalTitleBar, {
    visualSteps: visualSteps
  }, visualSteps ? /*#__PURE__*/_react.default.createElement(TopStepsWrapper, null, /*#__PURE__*/_react.default.createElement(Title, null, title), /*#__PURE__*/_react.default.createElement(VisualStepsWrapper, null, steps.map(function (_ref4) {
    var step = _ref4.step,
        label = _ref4.label;
    return /*#__PURE__*/_react.default.createElement(StepArrow, {
      key: step,
      active: currentStep >= step,
      fill: currentStep - 1 >= step && step < steps[steps.length - 1].step ? 1 : 0,
      first: step === 0,
      last: step === steps[steps.length - 1].step,
      isCurrentStep: currentStep === step,
      isPreviousStep: currentStep - 1 === step
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StepArrowLabel, null, label)));
  }))) : /*#__PURE__*/_react.default.createElement(ModalTitle, null, stepText, " ", currentStep + 1, "/", steps.length, /*#__PURE__*/_react.default.createElement(StepsWrapper, null, steps.map(function (_ref5) {
    var step = _ref5.step,
        label = _ref5.label;
    return step === currentStep && /*#__PURE__*/_react.default.createElement(StepLabel, {
      key: step
    }, label);
  }))), canClose ? /*#__PURE__*/_react.default.createElement(ModalCloser, {
    onClick: function onClick() {
      setShowModal(!showModal);
      onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_IconActionClose.default, {
    color: "#505050"
  })) : null), /*#__PURE__*/_react.default.createElement("div", null, children))));
};

var StepArrowLabel = _styledComponents.default.div.withConfig({
  displayName: "StepArrowLabel"
})(["display:flex;justify-items:center;align-items:center;margin:10px;color:#8990a3;z-index:1;cursor:", ";white-space:nowrap;font-weight:", ";"], function (_ref6) {
  var pointerEnabled = _ref6.pointerEnabled;
  return pointerEnabled ? 'pointer' : 'auto';
}, function (_ref7) {
  var isCurrentStep = _ref7.isCurrentStep;
  return isCurrentStep ? 700 : 500;
});

var TopStepsWrapper = _styledComponents.default.div.withConfig({
  displayName: "TopStepsWrapper"
})(["display:flex;flex-grow:1;align-items:center;padding:0 2rem;"]);

var StepsWrapper = _styledComponents.default.div.withConfig({
  displayName: "StepsWrapper"
})(["display:flex;flex-grow:1;align-items:center;"]);

var StepArrow = _styledComponents.default.div.withConfig({
  displayName: "StepArrow"
})(["display:flex;font-size:1.3rem;opacity:0.5;height:32px;", ""], function (_ref8) {
  var active = _ref8.active;
  return active ? (0, _styledComponents.css)(["> *{background-color:rgba(240,241,243,0.5);}opacity:1;", " ", " ", " ", " ", ""], function (_ref9) {
    var isCurrentStep = _ref9.isCurrentStep;
    return isCurrentStep && (0, _styledComponents.css)(["> *{background-color:rgba(240,241,243,1);}&:after{content:'';display:inline-block;border-top:16px solid transparent;border-bottom:16px solid transparent;border-left:16px solid rgba(240,241,243,1);}"]);
  }, function (_ref10) {
    var first = _ref10.first,
        isCurrentStep = _ref10.isCurrentStep;
    return !first && isCurrentStep && (0, _styledComponents.css)(["&:before{content:'';display:inline-block;border-top:16px solid rgba(240,241,243,1);border-bottom:16px solid rgba(240,241,243,1);border-left:16px solid rgba(240,241,243,0.5);}"]);
  }, function (_ref11) {
    var first = _ref11.first;
    return first && (0, _styledComponents.css)(["*{border-top-left-radius:5px;border-bottom-left-radius:5px;}"]);
  }, function (_ref12) {
    var last = _ref12.last,
        isCurrentStep = _ref12.isCurrentStep;
    return last && !isCurrentStep && (0, _styledComponents.css)(["&:after{content:'';display:inline-block;border-top:16px solid transparent;border-bottom:16px solid transparent;border-left:16px solid rgba(240,241,243,0.5);}"]);
  }, function (_ref13) {
    var fill = _ref13.fill,
        isPreviousStep = _ref13.isPreviousStep;
    return fill && !isPreviousStep && (0, _styledComponents.css)(["&:after{content:'';display:inline-block;border-top:0 solid transparent;border-bottom:0 solid transparent;border-left:16px solid rgba(240,241,243,0.5);}"]);
  }) : (0, _styledComponents.css)(["&:after{content:'';display:inline-block;border-top:16px solid transparent;border-bottom:16px solid transparent;border-left:16px solid transparent;}"]);
});

var Title = _styledComponents.default.h2.withConfig({
  displayName: "Title"
})(["color:black;font-size:2rem;font-weight:600;margin-right:2rem;"]);

var VisualStepsWrapper = _styledComponents.default.div.withConfig({
  displayName: "VisualStepsWrapper"
})(["display:flex;align-items:center;flex-grow:1;"]);

var StyledDrawer = (0, _styledComponents.default)(_reactDragDrawer.default).withConfig({
  displayName: "StyledDrawer"
})(["z-index:9999999;"]);

var ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "ModalContainer"
})(["background:white;width:", ";border:1px solid #ccc;box-shadow:0 0 8px rgba(0,0,0,0.1);border-radius:5px;display:flex;flex-direction:column;position:relative;font-family:", ";@media screen and (max-width:95rem){width:calc(100vw - 3rem);}"], function (_ref14) {
  var small = _ref14.small,
      large = _ref14.large;
  return small ? '50rem' : large ? '100rem' : '60rem';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.font;
});

var StepLabel = _styledComponents.default.p.withConfig({
  displayName: "StepLabel"
})(["color:black;text-transform:initial;margin-left:1rem;font-weight:bold;"]);

var ModalTitleBar = _styledComponents.default.div.withConfig({
  displayName: "ModalTitleBar"
})(["width:100%;height:", ";padding-left:2.2rem;border-bottom:1px solid #f0f1f3;display:flex;align-items:center;"], function (_ref16) {
  var visualSteps = _ref16.visualSteps;
  return visualSteps ? '8.5rem' : '6.5rem';
});

var ModalTitle = _styledComponents.default.h1.withConfig({
  displayName: "ModalTitle"
})(["flex-grow:1;color:#8990a3;display:flex;text-transform:uppercase;font-size:1.6rem;line-height:135%;text-align:left;font-weight:600;"]);

var ModalCloser = _styledComponents.default.a.withConfig({
  displayName: "ModalCloser"
})(["cursor:pointer;padding-right:3rem;&:hover{svg > path{fill:", ";}}"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.brand.primary;
});

var ModalActions = _styledComponents.default.div.withConfig({
  displayName: "ModalActions"
})(["width:100%;display:flex;justify-content:", ";margin-top:4rem;align-items:center;padding:3rem;background-color:#fbfbfb;border-top:1px solid #f0f1f3;> button{margin:0 1rem;&:first-of-type{margin-left:0;}&:last-of-type{margin-right:0;}}"], function (_ref18) {
  var position = _ref18.position;
  return handleActionsPosition(position);
});

var handleActionsPosition = function handleActionsPosition(position) {
  switch (position) {
    case 'left':
      return 'flex-start';

    case 'center':
      return 'center';

    case 'right':
      return 'flex-end';

    default:
      return 'flex-start';
  }
};

StyledModalActions.propTypes = {
  children: _propTypes.node,
  position: _propTypes.string,
  className: _propTypes.string
};
StyledModalActions.defaultProps = {
  position: 'right'
};
ModalContent.propTypes = {
  children: _propTypes.node,
  step: _propTypes.number
};
ModalContent.defaultProps = {
  step: 0
};
ModalWithSteps.propTypes = {
  title: _propTypes.string.isRequired,

  /** Set to true to make the modal closeable. */
  canClose: _propTypes.bool,
  children: _propTypes.node,
  showModal: _propTypes.bool,
  setShowModal: _propTypes.func.isRequired,

  /** Add this prop to display a smaller size of modal. */
  small: _propTypes.bool,

  /** Add this prop to display a larger size of modal. */
  large: _propTypes.bool,
  className: _propTypes.string,
  currentStep: _propTypes.number.isRequired,
  steps: _propTypes.array.isRequired,
  visualSteps: _propTypes.bool,

  /** Step text */
  stepText: _propTypes.string.isRequired,

  /** If a toast should be shown when trying to close the modal */
  showToast: _propTypes.bool,

  /** Text for the toast if shown */
  toastText: _propTypes.string,

  /** Time for toast to hide in seconds*/
  toastHideTime: _propTypes.number,

  /** FUnction to execute if closed */
  onClose: _propTypes.func
};
ModalWithSteps.defaultProps = {
  onClose: function onClose() {},
  canClose: true,
  showModal: false,
  toastHideTime: 5
};
ModalWithSteps.ModalActions = StyledModalActions;
ModalWithSteps.ModalActions.displayName = 'ModalWithSteps.ModalActions';
ModalWithSteps.ModalContent = ModalContent;
ModalWithSteps.ModalContent.displayName = 'ModalWithSteps.ModalContent';
var _default = ModalWithSteps;
exports.default = _default;